/**
 * @prop --foreground-color: Set the foreground color of the banner. 
 * @prop --background-color: Set the background color of the banner. 
 */

:host {
    box-sizing: border-box;
    position: absolute;
    z-index: 1;
    width: 200px;
    padding: 5px 60px;
    text-align: center;

    font-size: 12px;
    color: var(--foreground-color);
    background-color: var(--background-color);
    font-weight: 700;
    line-height: 1.3;

    will-change: transform;
    transform: translate3d(0, 0, 0);
}

:host([top][left]) {
    top: 0;
    left: -100px;
    transform-origin: top center;
    transform: translate(31px, 13px) rotate(-30deg);
}
:host([top][right]) {
    top: 0;
    right: -100px;
    transform-origin: top center;
    transform: translate(-31px, 13px) rotate(30deg);
}
:host([bottom][left]) {
    bottom: 0;
    left: -100px;
    transform-origin: bottom center;
    transform: translate(31px, -13px) rotate(30deg);
}
:host([bottom][right]) {
    bottom: 0;
    right: -100px;
    transform-origin: bottom center;
    transform: translate(-31px, -13px) rotate(-30deg);
}

:host([variant='error']) {
    --foreground-color: var(--color-error-contrast);
    --background-color: var(--color-error);
}

:host([variant='warning']) {
    --foreground-color: var(--color-warning-contrast);
    --background-color: var(--color-warning);
}

:host([variant='success']) {
    --foreground-color: var(--color-success-contrast);
    --background-color: var(--color-success);
}

:host([variant='info']) {
    --foreground-color: var(--color-info-contrast);
    --background-color: var(--color-info);
}
